import { Navigation } from '@app/navigation/enums/navigation.enum';
import { SettingsOfficesContainer } from '@app/real-estate-agent/containers/settings-offices/settings-offices.container';

export const officesRouting = {
    path: Navigation.Office,
    component: SettingsOfficesContainer,
};
